import script from "./Navigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=4f231a80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f231a80"]])

export default __exports__